// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/components/ModeSwitcher/ModeSwitcher.css */

.mode-switcher {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mode-switcher__label {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mode-switcher__label-icon {
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mode-switcher__label-icon svg {
  width: 12px;
  height: 12px;
  fill: var(--color-text-secondary);
}

.mode-switcher__options {
  display: flex;
  gap: 0;
  border-radius: var(--radius-full);
  overflow: hidden;
  border: 2px solid var(--color-wood-medium);
  background-color: var(--color-card-white);
}

.mode-switcher__option {
  flex: 1 1;
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-medium);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all var(--transition-fast);
  text-align: center;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
}

.mode-switcher__option--active {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
}

.mode-switcher__option:not(.mode-switcher__option--active):hover {
  background-color: rgba(139, 94, 60, 0.08);
}

.mode-switcher__option:not(.mode-switcher__option--active):active {
  background-color: rgba(139, 94, 60, 0.15);
}

.mode-switcher__option-icon {
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mode-switcher__option-icon svg {
  width: 14px;
  height: 14px;
  fill: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/components/ModeSwitcher/ModeSwitcher.css"],"names":[],"mappings":"AAAA,sGAAsG;;AAEtG;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,oCAAoC;EACpC,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,MAAM;EACN,iCAAiC;EACjC,gBAAgB;EAChB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,wCAAwC;EACxC,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/components/ModeSwitcher/ModeSwitcher.css */\n\n.mode-switcher {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.mode-switcher__label {\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.mode-switcher__label-icon {\n  width: 12px;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.mode-switcher__label-icon svg {\n  width: 12px;\n  height: 12px;\n  fill: var(--color-text-secondary);\n}\n\n.mode-switcher__options {\n  display: flex;\n  gap: 0;\n  border-radius: var(--radius-full);\n  overflow: hidden;\n  border: 2px solid var(--color-wood-medium);\n  background-color: var(--color-card-white);\n}\n\n.mode-switcher__option {\n  flex: 1;\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-medium);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  text-align: center;\n  white-space: nowrap;\n  -webkit-tap-highlight-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n}\n\n.mode-switcher__option--active {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n}\n\n.mode-switcher__option:not(.mode-switcher__option--active):hover {\n  background-color: rgba(139, 94, 60, 0.08);\n}\n\n.mode-switcher__option:not(.mode-switcher__option--active):active {\n  background-color: rgba(139, 94, 60, 0.15);\n}\n\n.mode-switcher__option-icon {\n  width: 14px;\n  height: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.mode-switcher__option-icon svg {\n  width: 14px;\n  height: 14px;\n  fill: currentColor;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
